import { Theme } from '@mui/material/styles'

/**
 * Builds every theme-dependent value used by the one-off field renderers.
 *
 * All Tidal-vs-legacy differences for `PestPacOptionField` and
 * `OpportunityStageField` are resolved here so the components themselves carry
 * no theme branching. Alongside the `sx` objects, `props` holds the handful of
 * differences that are not expressible as `sx` because they select a component
 * prop rather than a CSS value (a Typography `variant`, a Checkbox `edge`, and
 * the option list's `marginLeft`).
 *
 * @param theme The active MUI theme.
 * @param isTidalThemeActive Whether the Tidal theme is active.
 */
export const getStyles = (theme: Theme, isTidalThemeActive: boolean) => ({
  pestPacContainer: isTidalThemeActive
    ? { p: 2 }
    : { ml: 0, mr: 'auto', mt: 2, mb: 0 },

  pestPacHeader: {
    color: theme.palette.text.primary,
    mb: isTidalThemeActive ? 1 : 0,
    ml: isTidalThemeActive ? 7.3 : 7,
  },

  pestPacRow: isTidalThemeActive ? {} : { p: 2 },

  pestPacCheckboxWrapper: isTidalThemeActive ? { pr: 2 } : {},

  pestPacCheckbox: { marginTop: isTidalThemeActive ? '-38px' : '-35px' },

  props: {
    pestPacHeaderVariant: isTidalThemeActive
      ? ('h6' as const)
      : ('subtitle1' as const),
    pestPacCheckboxEdge: isTidalThemeActive ? undefined : ('start' as const),
    opportunityStageMarginLeft: isTidalThemeActive ? 9.62 : undefined,
  },
})
